import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import { apiSlice } from './api/apiSlice';
import accessibilityReducer from './reducers/accessibilitySlice';
import authReducer from './reducers/authSlice';
import loadingReducer from './reducers/loadingSlice';
import snackbarReducer from './reducers/snackbarSlice';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    snackbar: snackbarReducer,
    loading: loadingReducer,
    theme: accessibilityReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/FLUSH',
          'persist/REGISTER',
          'persist/PURGE',
        ],
      },
    }).concat(apiSlice.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
